import tick from '@/modules/tick/tick'; // for waiting
import IMSData from '@/modules/ims-service/ims-data'; // data service for our API
import JWTDecode from 'jwt-decode'; // used to decode window._bearer from indycar apps
import ImsError from '@/modules/errors/errors'; // for processing errors
import AppConfig from '@/AppConfig';

declare var window: any; // for allowing window._bearer
export default class User {
  public $auth: any;
  public account: any;
  public loggedIn: Boolean = false;
  private changeListeners: Array<Function> = [];
  public service: IMSData; // Holder of the IMS API and Data
  public profile: any = null;

  public constructor() {
    // Set up API for this User
    this.service = new IMSData();
  }
  /**
   * User Initialize
   */
  public async init(): Promise<any> {
    /**
     *Check if IndyCar _bearer variable is present
     * The app will set window._bearer with the users
     * token from the app. If it exists
     * we will assume the user is logged in
     */
    if (window._bearer) {
      // Decode the Bearer
      let payload: any = JWTDecode(window._bearer);
      // Is it
      if (payload.oid) {
        // Valid payload - let's use this bearer instead
        this.account = payload;
      } else {
        console.error(
          'An invalid window._bearer token was provided. Not accepting it'
        );
      }
    } else {
      // No window._bearer token - use normal auth
      this.account = null;
    }

    // Does the account exist?
    if (this.account) {
      this.setLoggedIn();
    } else {
      // Fire Logged Out
      this.setLoggedOut();
    }
    return this;
  }

  /**
   * Load the Profile and set it user.profile
   * also return it.
   */
  public async loadProfile(): Promise<any | ImsError> {
    try {
      let profile: any = await this.service.getProfile();
      return profile;
    } catch (e) {
      // This catches all of the various errors that might take place
      // -- invalid bearer, expired b2c, adblocker blocking, etc.
      let profileError = new ImsError(e);
      //  selectively throw the error depending on if error is throwable.
      profileError.throw();
    }
  }

  /**
   * Set the users state to logged in
   * This kicks off the fireChange
   * anyting using the $User.onChange
   * will hear this.
   */
  private setLoggedIn(): void {
    if (this.account) {
      this.loggedIn = true;
      this.fireChange('logged-in');
    }
  }
  /**
   * Set the users state to LOGGED OUT
   */
  private setLoggedOut(): void {
    this.loggedIn = false;
    this.fireChange('logged-out');
  }

  /**
   * Log the User in
   */
  public async login(): Promise<User> {
    // Setup a login Success holder
    let loginSuccess = false;
    window.location.href = `${window.location.origin}${AppConfig.sso.login}`;
    return this;
  }

  // Delete all storage and cookies
  private deleteEverything(): void {
    // Delete Local Storage
    localStorage.clear();
    sessionStorage.clear();
    // Delete ALL cookies
    document.cookie.split(';').forEach(function(c) {
      document.cookie = c
        .replace(/^ +/, '')
        .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/');
    });
  }

  // Log the user out
  public async logout(): Promise<boolean> {
    // Is this a Standlone b2c Broker

    window.location.href = `${window.location.origin}${AppConfig.sso.logout}`;

    // if (window._standalone) {
    //   // Redirect user to SSO
    //   window.location.href = `${window.location.origin}${AppConfig.sso.logout}`;
    // } else {
    //   try {
    //     // Tell auth to logout
    //     await this.$auth.logout();
    //     // wait 200 ms
    //     await tick(200);
    //     // delete cookies and local storage
    //     this.deleteEverything();
    //   } catch (e) {
    //     // catch any errors
    //     console.error('logout error', e.message);
    //     // still delete everything
    //     this.deleteEverything();
    //   }
    //   // Redirect to home
    //   document.location.href = '/';
    // }

    return true;
  }

  /**
   * Fire Change to User
   * @param type string
   */
  private fireChange(type: string): void {
    this.changeListeners.forEach((func: Function) => {
      func(type, this);
    });
  }

  /**
   * onChange event Listener
   * @param func Function
   */
  public onChange(func: Function): void {
    if (this.changeListeners.indexOf(func) == -1) {
      this.changeListeners.push(func);
    }
  }

  /**
   * Is the User Logged In?
   */
  public isLoggedIn(): boolean {
    return this.account ? true : false;
  }
}
